// libraries
import cn from 'classnames'
import Button from 'ext-ui/components/Button/Button'
import { createLocation } from 'history'
import Markdown from 'markdown-to-jsx'
import moment from 'moment'
import queryString from 'query-string'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import LoadingBackgroundPage from 'src/components/LoadingBackgroundPage/LoadingBackgroundPage'
import { useTranslate } from 'src/localization/Trns'
import { connectedPush } from 'src/navigation/Lnk'
import { activityUrl } from 'src/navigation/urls'
import { useFetchNotificationDetails } from 'src/queries/activity.queries'
import { LocationState } from 'src/redux/createRootReducer'
import { selectLocationFromState } from 'src/redux/selectors/router.selectors'

import style from './NotificationDetails.style'

const NotificationDetails: React.FC = () => {
  const translate = useTranslate()
  const dispatch = useDispatch()
  const [id, setId] = React.useState<string | undefined>(undefined)

  const location = useSelector(selectLocationFromState)
  useEffect(() => {
    if (location.pathname !== activityUrl()) { return }

    queryString.parse(location.search)
    const params = queryString.parse(location.search)
    const notificationId = params.id ? (params.id as string) : undefined
    
    setId(notificationId)
  }, [location.search])

  const { data, isPending } = useFetchNotificationDetails(id)

  if (isPending || !data) {
    return <LoadingBackgroundPage />
  }

  return (
    <div css={style} className={cn('NotificationDetails')}>
      <div className={cn('NotificationDetails-title')}>
        {data?.subject}
      </div>
      <div className={cn('NotificationDetails-description')}>
        <Markdown options={{ disableParsingRawHTML: true }} className={cn('NotificationDetails-description-body')}>
          {data?.body}
        </Markdown>
        <div className={cn('NotificationDetails-description-timestamp')}>
          {translate('${date} at ${time}', {
            date: moment(data?.timestamp).format('L'),
            time: moment(data?.timestamp).format('LTS'),
          })}
        </div>
      </div>
      {data?.action && data?.actionText && <div className={cn('NotificationDetails-action')}>
        <Button onClick={() => {
          dispatch(connectedPush(createLocation<LocationState>(data.action)))
        }}>
          {data.actionText}
        </Button>
      </div>}
    </div>
  )
}

export default NotificationDetails
